/* eslint-disable @typescript-eslint/no-namespace,no-shadow */

export namespace TestTypes {
  export namespace Onboarding {
    export enum QuestionKeys {
      firstName= 'firstName',
      lastName= 'lastName',
      businessMainIndustry= 'businessMainIndustry',
      companyName = 'company-name',
      companyAddressStreet = 'company-address-street',
      companyAddressCity = 'company-address-city',
      companyAddressState = 'company-address-state',
      companyWebsiteUrl = 'company-website'
    }
  }
}
